import { render, staticRenderFns } from "./ProductTileFeels.vue?vue&type=template&id=f7cdf9f2&"
import script from "./ProductTileFeels.vue?vue&type=script&lang=js&"
export * from "./ProductTileFeels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AppInfoModal: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/common/AppInfoModal.vue').default})
